export const buildCarPayload = ({ addressData, contactId }) => {
  let heatingMode = ''
  let cookingMode = ''
  let hotWaterMode = ''
  switch (addressData?.heatingEnergy) {
    case 'elec':
      heatingMode = 'ELECTRICITY'
      break
    case 'gas':
      heatingMode = 'NATURAL_GAS'
      break
    default:
      heatingMode = 'OTHER'
      break
  }
  switch (addressData?.cookingEnergy) {
    case 'elec':
      cookingMode = 'ELECTRICITY'
      break
    case 'gas':
      cookingMode = 'NATURAL_GAS'
      break
    default:
      cookingMode = 'OTHER'
      break
  }
  switch (addressData?.hotwaterEnergy) {
    case 'elec':
      hotWaterMode = 'ELECTRICITY'
      break
    case 'gas':
      hotWaterMode = 'NATURAL_GAS'
      break
    default:
      hotWaterMode = 'OTHER'
      break
  }

  return {
    version: 'v2',
    contactId,
    addressId: addressData?.id ?? 0,
    housingType: addressData?.housingType === 'apartment' ? 'FLAT' : 'HOUSE',
    surface: addressData?.surface || 0,
    mainHome: addressData?.residenceType === 'main' ? 'MAIN' : 'SECONDARY',
    occupantsNumber: addressData?.energyLandscape?.numberOfOccupants || 0,
    heatingMode,
    cookingMode,
    hotWaterMode,
    rawHeating: addressData?.heatingEnergy || '',
    rawCooking: addressData?.cookingEnergy || '',
    rawHotWater: addressData?.hotwaterEnergy || '',
    occupancyFrequency: addressData?.energyLandscape?.residencePresence === '0' ? 'ALL_DAY' : 'NIGHT_WE',
    recentInsulationWork: addressData?.energyLandscape?.recentInsulationWork || '',
    dishwasher: addressData?.energyLandscape?.dishwasher === true ? 'true' : '',
    dryer: addressData?.energyLandscape?.dryer === true ? 'true' : '',
    separateFreezer: addressData?.energyLandscape?.freezer === true ? 'true' : '',
    electricCar: addressData?.energyLandscape?.electricCar === true ? 'true' : '',
    electricCarDistance: addressData?.energyLandscape?.electricCarDistance || 0,
    airConditionersOneRoom: addressData?.energyLandscape?.airConditionersOneRoom === true ? 'true' : '',
    airConditionersMultipleRooms: addressData?.energyLandscape?.airConditionersMultipleRooms === true ? 'true' : '',
    heatPump: addressData?.energyLandscape?.heatPump === true ? 'true' : '',
    numberDays: addressData?.energyLandscape?.numberDays || 0,
  }
}
